import React, { useState, useEffect, useRef, memo } from "react";
import useComponentVisible from "./useComponentVisible";
import "./TTSelect.css";

const MemoizedImg = memo(function MemoizedImg({ src }) {
  return <img src={src} loading="lazy" />;
});

const Options = memo(function Options(props) {
  const { option, onClick } = props;

  return (
    <div className="tt-options" onClick={onClick}>
      {option.img ? (
        <div className="tt-option-img">
          <MemoizedImg src={option.img}></MemoizedImg>
        </div>
      ) : (
        <div className="tt-option-img"></div>
      )}
      <div className="tt-option-txt">{option?.text}</div>
    </div>
  );
});

export default function TTSelect(props) {
  const { options, value, placeholder, onChange } = props;

  const [selected, setSelected] = useState(
    value
      ? value
      : {
          id: null,
          text: placeholder,
          img: "",
        }
  );
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);

  useEffect(() => {
    setIsComponentVisible(false);
    if (selected?.code) {
      onChange(selected);
    }
  }, [selected]);

  useEffect(() => {
    if (!value) {
      setSelected({
        id: null,
        text: placeholder,
        img: "",
      });
    } else {
      setSelected(value);
    }
  }, [JSON.stringify(value)]);

  // useEffect(() => {
  //   if (!options) {
  //     return;
  //   }

  //   setSelected({
  //     id: null,
  //     text: placeholder,
  //     img: "",
  //   });
  // }, [JSON.stringify(options)]);

  return (
    <div className="tt-select">
      <div
        className="tt-select-selected"
        onClick={() => setIsComponentVisible(!isComponentVisible)}
      >
        <Options
          key={`option-null`}
          option={{ ...selected }}
          onClick={() => {}}
        />
        <div className="tt-select-btn">
          <svg
            style={{
              transform: isComponentVisible ? "rotate(180deg)" : "none",
            }}
            xmlns="http://www.w3.org/2000/svg"
            width="45"
            height="45"
            viewBox="0 0 45 45"
            fill="none"
            rotate={90}
          >
            <rect width="45" height="45" rx="3" fill="#F5F5F5" />
            <path
              d="M18.41 21L23 25.59L27.59 21L29 22.42L23 28.42L17 22.42L18.41 21Z"
              fill="black"
            />
          </svg>
        </div>
      </div>

      <div
        ref={ref}
        className={`tt-select-options-container ${
          !isComponentVisible && "hide"
        }`}
      >
        <button
          onClick={() => setIsComponentVisible(false)}
          className="tt-close modal-menu-close"
          style={{
            background: "none",
            border: "none",
            width: "48px",
            height: "48px",
            position: "absolute",
            right: 1,
            zIndex: 1,
            padding: 0,
          }}
        >
          <span
            style={{
              background: "#666",
              display: "block",
              width: "70%",
              height: "2px",
              position: "absolute",
              left: "9%",
              transform: "rotate(-45deg)",
            }}
          ></span>
          <span
            style={{
              background: "#666",
              display: "block",
              width: "70%",
              height: "2px",
              position: "absolute",
              left: "9%",
              transform: "rotate(45deg)",
            }}
          ></span>
        </button>
        {options?.map(
          (o, k) =>
            o.id !== selected?.id && (
              <Options
                onClick={() => setSelected(o)}
                key={`option-${k}`}
                option={o}
              />
            )
        )}
      </div>
    </div>
  );
}
